<!--
Tekstiredaktor, mis kasutab Tiptap pluginat
Inspiratsioon: https://www.youtube.com/watch?v=qmthtmQ6pP4&t=1s
-->
<template>
  <div class="menu-buttons" v-if="editor">
    <select class="menu-select" :value="activeFontFamily" title="Font family" @change="onFontFamilyChange">
      <option value="">Font</option>
      <option v-for="option in fontFamilyOptions" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
    <select class="menu-select" :value="activeFontSize" title="Font size" @change="onFontSizeChange">
      <option value="">Size</option>
      <option v-for="size in fontSizeOptions" :key="size" :value="size">
        {{ size }}
      </option>
    </select>
    <button title="Vali pilt galeriist" @click.prevent.stop="openImagePicker">
      <i class="ri-image-line"></i>
    </button>
    <button title="YouTube video" id="add" @click.prevent.stop="addVideo">
      <i class="ri-video-line"></i>
    </button>
    <button title="Set link" @click.prevent.stop="setLink" :class="{ 'is-active': editor.isActive('link') }">
      <i class="ri-link"></i>
    </button>
    <button title="Unset link" @click.prevent.stop="editor.chain().focus().unsetLink().run()" :disabled="!editor.isActive('link')">
      <i class="ri-link-unlink"></i>
    </button>
    <button title="Blockquote" @click.prevent.stop="editor.chain().focus().toggleBlockquote().run()" :class="{ 'is-active': editor.isActive('blockquote') }">
      <i class="ri-double-quotes-l"></i>
    </button>
    <button title="Bold" @click.prevent.stop="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
      <i class="ri-bold"></i>
    </button>
    <button title="Italic" @click.prevent.stop="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
      <i class="ri-italic"></i>
    </button>
    <button title="Strike" @click.prevent.stop="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }">
      <i class="ri-strikethrough"></i>
    </button>
    <button title="Heading 1" @click.prevent.stop="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }">
      <i class="ri-h-1"></i>
    </button>
    <button title="Heading 2" @click.prevent.stop="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
      <i class="ri-h-2"></i>
    </button>
    <button title="Heading 3" @click.prevent.stop="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
      <i class="ri-h-3"></i>
    </button>
    <button title="Heading 4" @click.prevent.stop="editor.chain().focus().toggleHeading({ level: 4 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }">
      <i class="ri-h-4"></i>
    </button>
    <button title="Paragraph" @click.prevent.stop="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': editor.isActive('paragraph') }">
      <i class="ri-paragraph"></i>
    </button>
    <button title="Bullet list" @click.prevent.stop="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList', { padding: '20px' }) }">
      <i class="ri-list-unordered"></i>
    </button>
    <button title="Ordered list" @click.prevent.stop="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }">
      <i class="ri-list-ordered"></i>
    </button>
    <button title="Highlight" @click.prevent.stop="editor.chain().focus().toggleHighlight().run()" :class="{ 'is-active': editor.isActive('highlight') }">
      <i class="ri-mark-pen-line"></i>
    </button>
    <button title="Align left" @click.prevent.stop="editor.chain().focus().setTextAlign('left').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }">
      <i class="ri-align-left"></i>
    </button>
    <button title="Align center" @click.prevent.stop="editor.chain().focus().setTextAlign('center').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }">
      <i class="ri-align-center"></i>
    </button>
    <button title="Align right" @click.prevent.stop="editor.chain().focus().setTextAlign('right').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }">
      <i class="ri-align-right"></i>
    </button>
    <button title="Align justify" @click.prevent.stop="editor.chain().focus().setTextAlign('justify').run()" :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }">
      <i class="ri-align-justify"></i>
    </button>
    <button title="Hard break" @click.prevent.stop="editor.chain().focus().setHardBreak().run()">
      <i class="ri-text-wrap"></i>
    </button>
    <button title="Undo" @click.prevent.stop="editor.chain().focus().undo().run()" :disabled="!editor.can().chain().focus().undo().run()">
      <i class="ri-arrow-go-back-line"></i>
    </button>
    <button title="Redo" @click.prevent.stop="editor.chain().focus().redo().run()" :disabled="!editor.can().chain().focus().redo().run()">
      <i class="ri-arrow-go-forward-line"></i>
    </button>
  </div>
  <editor-content class="edits" :editor="editor" />
  <v-dialog v-model="imagePickerDialog" max-width="900">
    <v-card>
      <v-toolbar color="white" title="Vali pilt galeriist">
        <v-btn icon="mdi-close" @click="imagePickerDialog = false"></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-file-input
            v-model="selectedImage"
            label="Sisesta pildid"
            variant="outlined"
            prepend-icon="mdi-camera"
            accept="image/*"
            multiple
            :loading="uploadingImage"
            @update:modelValue="uploadImage"
        ></v-file-input>
        <p v-if="uploadError" class="cloudinary-error">{{ uploadError }}</p>
        <v-btn
            class="mb-4"
            color="eraklient"
            variant="outlined"
            :loading="loadingCloudinaryImages"
            @click="fetchCloudinaryImages"
        >
          Lae pildid
        </v-btn>
        <p v-if="cloudinaryError" class="cloudinary-error">{{ cloudinaryError }}</p>
        <div v-if="cloudinaryImages.length" class="cloudinary-gallery">
          <div
              v-for="image in cloudinaryImages"
              :key="image.public_id"
              class="cloudinary-item"
          >
            <button
                type="button"
                class="cloudinary-select"
                @click="selectGalleryImage(image.url)"
            >
              <img :src="image.url" :alt="image.public_id"/>
            </button>
            <v-btn
                class="cloudinary-delete"
                size="x-small"
                icon="mdi-delete"
                color="error"
                :loading="deletingPublicId === image.public_id"
                @click.stop="openDeleteCloudinaryDialog(image)"
            ></v-btn>
          </div>
        </div>
        <p v-else-if="!loadingCloudinaryImages" class="cloudinary-empty">
          Galerii on tühi või pildid pole veel laetud.
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-dialog v-model="deleteImageDialog" width="auto" transition="none">
    <v-card min-width="360">
      <v-toolbar color="white" title="Kinnitus">
        <v-btn icon="mdi-close" @click="closeDeleteCloudinaryDialog"></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-alert type="warning" variant="tonal" border="start" prominent>
          Kas oled kindel, et soovid selle pildi kustutada?
        </v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <div class="ma-4">
        <v-btn
            class="text-none mr-4 font-weight-bold"
            color="error"
            min-width="92"
            rounded
            :loading="deletingPublicId === pendingDeleteImage?.public_id"
            @click="confirmDeleteCloudinaryImage"
        >
          Jah
        </v-btn>
        <v-btn class="text-none font-weight-bold" min-width="92" rounded @click="closeDeleteCloudinaryDialog">
          Ei
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { useEditor, EditorContent } from '@tiptap/vue-3'
import Blockquote from '@tiptap/extension-blockquote'
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import FontFamily from '@tiptap/extension-font-family'
import StarterKit from '@tiptap/starter-kit'
import Image from '@tiptap/extension-image'
import { SmilieReplacer } from '@/assets/SmileReplacer.ts'
import Typography from '@tiptap/extension-typography'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Youtube from '@tiptap/extension-youtube'
import Link from '@tiptap/extension-link'
import { Extension } from '@tiptap/core'
import {ref, watch} from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  }
});

const emit = defineEmits(['update:modelValue']);

const imagePickerDialog = ref(false);
const loadingCloudinaryImages = ref(false);
const cloudinaryError = ref('');
const cloudinaryImages = ref([]);
const deletingPublicId = ref(null);
const deleteImageDialog = ref(false);
const pendingDeleteImage = ref(null);
const selectedImage = ref(null);
const uploadingImage = ref(false);
const uploadError = ref('');
const activeFontFamily = ref('');
const activeFontSize = ref('');

const fontFamilyOptions = [
  { label: 'Inter', value: 'Inter' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'Courier New', value: 'Courier New' },
  { label: 'Verdana', value: 'Verdana' },
];

const fontSizeOptions = ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px'];

const FontSize = Extension.create({
  name: 'fontSize',

  addOptions() {
    return {
      types: ['textStyle'],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize || null,
            renderHTML: (attributes) => {
              if (!attributes.fontSize) {
                return {};
              }

              return { style: `font-size: ${attributes.fontSize}` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontSize:
          (fontSize) =>
              ({ chain }) => {
                return chain().setMark('textStyle', { fontSize }).run();
              },
      unsetFontSize:
          () =>
              ({ chain }) => {
                return chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run();
              },
    };
  },
});

const updateActiveTextStyle = () => {
  if (!editor.value) return;
  const attributes = editor.value.getAttributes('textStyle');
  activeFontFamily.value = attributes.fontFamily || '';
  activeFontSize.value = attributes.fontSize || '';
};

const onFontFamilyChange = (event) => {
  const value = event.target.value;
  if (!editor.value) return;

  if (value) {
    editor.value.chain().focus().setFontFamily(value).run();
  } else {
    editor.value.chain().focus().unsetFontFamily().run();
  }

  updateActiveTextStyle();
};

const onFontSizeChange = (event) => {
  const value = event.target.value;
  if (!editor.value) return;

  if (value) {
    editor.value.chain().focus().setFontSize(value).run();
  } else {
    editor.value.chain().focus().unsetFontSize().run();
  }

  updateActiveTextStyle();
};

const editor = useEditor({
  content: props.modelValue,
  extensions: [
      StarterKit,
      TextStyle,
      FontFamily,
      FontSize,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      Highlight,
      Image,
      Typography,
      SmilieReplacer,
      Youtube.configure({
        controls: false,
      }),
      Link.configure({
        openOnClick: true,
      }),
      Blockquote.configure({
        HTMLAttributes: {
          class: 'my-custom-svg',
        },
      })
  ],
  onUpdate: () => {
    emit('update:modelValue', editor.value.getHTML());
    updateActiveTextStyle();
  },
  onSelectionUpdate: () => {
    updateActiveTextStyle();
  },
  onCreate: () => {
    updateActiveTextStyle();
  },
});


watch(
    () => props.modelValue,
    value => {
      const isSame = editor.value.getHTML() === value;
      if (isSame) {
        return;
      }
      editor.value.commands.setContent(value, false);
    },
);

const fetchCloudinaryImages = async () => {
  loadingCloudinaryImages.value = true;
  cloudinaryError.value = '';

  try {
    const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/images?t=${Date.now()}`, {
      method: 'GET',
      credentials: 'include',
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Failed to load Cloudinary images');
    }

    cloudinaryImages.value = Array.isArray(data) ? data : [];
  } catch (error) {
    cloudinaryError.value = 'Cloudinary piltide laadimine ebaonnestus';
    console.log(error);
  } finally {
    loadingCloudinaryImages.value = false;
  }
};

const openImagePicker = async () => {
  imagePickerDialog.value = true;

  if (!cloudinaryImages.value.length) {
    await fetchCloudinaryImages();
  }
};

const uploadImage = async (fileInput) => {
  const files = Array.isArray(fileInput) ? fileInput : (fileInput ? [fileInput] : []);
  if (!files.length) return;

  uploadError.value = '';
  uploadingImage.value = true;

  try {
    for (const file of files) {
      const formData = new FormData();
      formData.append('image', file);

      const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/image`, {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Image upload failed');
      }

    }

    selectedImage.value = null;
    await fetchCloudinaryImages();
  } catch (error) {
    uploadError.value = 'Pildi üleslaadimine ebaõnnestus';
    console.log(error);
  } finally {
    uploadingImage.value = false;
  }
};

const selectGalleryImage = (url) => {
  if (!url || !editor.value) return;

  editor.value.chain().focus().setImage({ src: url }).run();
  imagePickerDialog.value = false;
};

const openDeleteCloudinaryDialog = (image) => {
  pendingDeleteImage.value = image;
  deleteImageDialog.value = true;
};

const closeDeleteCloudinaryDialog = () => {
  deleteImageDialog.value = false;
  pendingDeleteImage.value = null;
};

const confirmDeleteCloudinaryImage = async () => {
  const image = pendingDeleteImage.value;
  if (!image?.public_id) return;

  cloudinaryError.value = '';
  deletingPublicId.value = image.public_id;

  try {
    const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/image`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ public_id: image.public_id }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Image delete failed');
    }

    cloudinaryImages.value = cloudinaryImages.value.filter((item) => item.public_id !== image.public_id);
  } catch (error) {
    cloudinaryError.value = 'Pildi kustutamine ebaonnestus';
    console.log(error);
  } finally {
    deletingPublicId.value = null;
    closeDeleteCloudinaryDialog();
  }
};

const addVideo = () => {
  const url = prompt('Enter YouTube URL')

  if (url) {
    editor.value.commands.setYoutubeVideo({
      src: url,
      width: "100%",
    })
  }
};

const setLink = () => {
  const previousUrl = editor.value.getAttributes('link').href
  const url = window.prompt('URL', previousUrl)

  if (url === null) {
    return
  }

  if (url === '') {
    editor.value
        .chain()
        .focus()
        .extendMarkRange('link')
        .unsetLink()
        .run()

    return
  }

  editor.value
      .chain()
      .focus()
      .extendMarkRange('link')
      .setLink({ href: url })
      .run()
};
</script>


<style lang="scss">
.tiptap {
  margin-top: 1rem;
  padding: 20px;
  border: 1px solid black;
  border-radius: 0.3rem;
  overflow-wrap: break-word;
  cursor: text;

  > * + * {
    margin-top: 0.75em;
  }

  a {
    color: #0041EB;
    font-weight: bold;
  }

  .my-custom-svg::before {
    content: url('@/assets/images/simplequote.svg');
  }

  blockquote {
    display: flex;
    align-items: center;
    background: #eeeeee;
    text-align: left;
    justify-content: left;
    font-style: italic;
    border-radius: 8px;
    padding: 15px;
  }

  blockquote p {
    padding-left: 15px;
  }

  a:hover {
    text-decoration: underline;
  }

  ul,
  ol {
    padding: 0 1.5rem;
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.5em;
  }

  h3 {
    font-size: 1.17em;
  }

  h4 {
    font-size: 1em;
  }

  h1,
  h2,
  h3,
  h4
  {
    line-height: 1.2;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  mark {
    background-color: #FAF594;
  }

  pre {
    background: #0D0D0D;
    color: #FFF;
    font-family: 'JetBrainsMono', monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

  code {
    color: inherit;
    padding: 0;
    background: none;
    font-size: 0.8rem;
  }

  }

  img {
    max-width: 100%;
    height: auto;
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0D0D0D, 0.1);
    margin: 2rem 0;
  }
}

.menu-buttons button {
  font-size: inherit;
  font-family: inherit;
  color: #000;
  margin: 0.1rem;
  border: 1px solid black;
  border-radius: 0.3rem;
  padding: 0.1rem 0.4rem;
  background: white;
  accent-color: black;
}

.menu-select {
  font-size: inherit;
  font-family: inherit;
  color: #000;
  margin: 0.1rem;
  border: 1px solid black;
  border-radius: 0.3rem;
  padding: 0.15rem 0.4rem;
  background: white;
}

.menu-buttons .is-active {
  background: black;
  color: #fff;
}

.cloudinary-error {
  margin-bottom: 0.75rem;
  color: #b00020;
}

.cloudinary-empty {
  margin: 0;
}

.cloudinary-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.cloudinary-item {
  position: relative !important;
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  padding: 0;
  background: transparent;
}

.cloudinary-select {
  display: block;
  width: 100%;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.cloudinary-select img {
  display: block;
  width: 100%;
  height: 120px;
  object-fit: cover;
}

.cloudinary-delete {
  position: absolute !important;
  top: 6px !important;
  right: 6px !important;
  left: auto !important;
  bottom: auto !important;
  z-index: 3;
}
</style>